



import { Component, Vue } from 'vue-property-decorator';

import RedirectButtonControl from "@/components/Molecules/RedirectButtonControl/RedirectButtonControl.vue";
import HeaderLogo from "@/components/Atoms/HeaderLogo/HeaderLogo.vue";
import AuthFooter from "@/views/layout/auth/auth-footer/AuthFooter.vue";
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate"
]);
@Component({
  components: {
    RedirectButtonControl,
    HeaderLogo,
    AuthFooter,
    SvgRender
  }
})
export default class AuthLayout extends Vue {
  private isShowBackButton = false
  private checkShowFooter = true
  private checkShowHeader = true
  private checkShowButtonBack = false
  private currentRoute = ''

  private created(): void {
    this.currentRoute = this.$route.name || ''
    this.isShowBackButton = this.$route.meta && this.$route.meta.showButtonControl
    this.handlerShowBackButton()
    this.handlerShowFooterAndHeader()
  }
  private onClickBackPage(): void {
    if(['routes.auth.resetPasswordSuccess', 'routes.auth.forgotPassword', 'routes.auth.register'].includes(this.currentRoute)) {
      this.$router.push({ name: 'routes.auth.login'})
    } else {
      this.$router.go(-1)
    }
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    this.currentRoute = to.name
    this.handlerShowBackButton()
    this.handlerShowFooterAndHeader()
    next();
  }

  private handlerShowFooterAndHeader():void {
    if(['routes.tutorial'].includes(this.currentRoute)) {
      this.checkShowFooter = false
      this.checkShowHeader = false
    } else {
      this.checkShowFooter = true
      this.checkShowHeader = true
    }
  }

  private handlerShowBackButton():void {
    if([
      'routes.auth.forgotPassword',
      'routes.auth.resetPasswordSuccess',
      'routes.auth.register'
    ].includes(this.currentRoute)) {
      this.checkShowButtonBack = true
    } else {
      this.checkShowButtonBack = false
    }
  }
}
